import { WebComponentBaseClass } from "../third_party/web-component-base-class/dist/web-component-base-class.js";

const webComponentName = "vicowa-introduction";
window.customElements.define(webComponentName, class extends WebComponentBaseClass {
	static get is() { return webComponentName; }
	constructor() { super(); }
	static get template() {
		return `
	<style>
	:host {
			display: block;
			padding: 10px;
		}
	</style>
		<h2>My personal collection of interesting or useful things</h2>
		This website will contain my web experiments, articles about webdesign, javascript and linux. I hope that the things that are interesting to me will also be of interest to other people.
		`;
	}
});
